import React, { useEffect, useState } from "react";
import homeStyle from "./styles";
import EarlyAccessBtn from "../Buttons/EarlyAccessBtn";
import LoginScreen from "../Layout/LoginScreen";
import { Link, Box, Typography, Modal, Backdrop, Slide } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Alert from "../../pages/alert/received-message";
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import { useRouter } from "next/router";
import { setUserDetail } from "../../src/redux/actions";
import eventBus from "../../util/eventBus";
import auth from "../Layout/util/auth";
import TagManager from "react-gtm-module";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TopSection = ({ props, featureSong }) => {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  var router = useRouter();
  var openWaitList = props?.openWaitList;
  const [featureSongvalue, setFeatureSongvalue] = useState([]);
  const [isMobile, setIsMobile] = useState(true);
  const [name, setName] = useState("");
  const [nameUpdateError, setNameUpdateError] = useState(false);
  const [show, setShow] = useState(true);
  const [hidecommunitypopup, sethidecommunitypopup] = useState(false);
  const { profile, id } = useSelector((state) => state.user);
  const [emailVerified, setEmailVerified] = useState(false);

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    let val = localStorage.getItem("isEmailVerified");
    if (val == "true") {
      setEmailVerified(true);
    } else {
      setEmailVerified(false);
    }
  }, []);
  useEffect(() => {
    if (emailVerified) {
      setTimeout(() => {
        localStorage.setItem("isEmailVerified", "false");
        setEmailVerified(false);
      }, 5000);
    }
  }, [emailVerified]);

  useEffect(() => {
    console.log(featureSong.sort((a, b) => b?.id - a?.id));
    const kaleghodeObj = featureSong.find(
      (item) => item.attributes.Title == "Kaale Ghode"
    );
    const kaleghodeObjIndex = featureSong.findIndex(
      (item) => item.attributes.Title == "Kaale Ghode"
    );
    featureSong.splice(kaleghodeObjIndex, 1);
    featureSong.unshift(kaleghodeObj);
    setFeatureSongvalue(featureSong);
  }, []);

  const { mutate: updateName } = useMutation(
    ({ name, id }) => fetcher.patch(`/v1/user/${id}`, { name }),
    {
      onSuccess: (response) => {
        localStorage.setItem("userName", name);
        dispatch(
          setUserDetail({
            ...profile,
            name: name,
          })
        );
      },
      onError: (error) => {
        setNameUpdateError(true);
      },
    }
  );

  const hidePopup = () => {
    if (typeof window !== "undefined") {
      // do your stuff with sessionStorage
      sethidecommunitypopup(sessionStorage.setItem("Communitypopup", "true"));
    }
    setShow(false);
  };

  if (typeof window !== "undefined") {
    // do your stuff with sessionStorage
    hidecommunitypopup = sessionStorage.getItem("Communitypopup");
  }

  const r = auth();
  const handleReserve = (e, id) => {
    if (r.token) {
      router.push("/nft/9-9-mashukan");
    } else {
      eventBus.dispatch("openLoginModal", { function_name: "uniqueCommunity" });
    }
  };

  const handleBuyNow = () => {
    if (!r.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "knowMore",
          userStatus: "Guest",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "knowMore",
          userStatus: "login",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const updateUserName = () => {
    if (name.length < 2) {
      setNameUpdateError(true);
    } else {
      setNameUpdateError(false);
      if (name && id) {
        updateName({ name, id });
      }
    }
  };
  var settings = {
    dots: false,
    arrows: true,
    useTransform: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const handleMoredetails = (data) => {
    if (r?.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "More Details",
          songName: data?.attributes?.Title,
          userStatus: "login",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "More Details",
          songName: data?.attributes?.Title,
          userStatus: "Guest",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
    router.push(data?.attributes?.nft_slug);
  };

  console.log("featureSongvalue", featureSongvalue);
  return (
    <Box sx={homeStyle.root}>
      <Alert
        visible={emailVerified}
        message={"Your email has been successfully verified."}
      />
      <Box sx={homeStyle.bannerContainer}>
        <Typography variant="h2" sx={homeStyle.bannerTitle}>
          INVEST IN MUSIC
        </Typography>
        <Typography variant="h1" sx={homeStyle.bannerSubTitle}>
          EARN ROYALTY INCOME & PRIVILEGES
        </Typography>
        <Link
          onClick={() => window.location.replace("/#Howitwork")}
          style={{ cursor: "pointer", textDecoration: "underline !important" }}
          href="javascript:void(0)"
        >
          How It Works?
        </Link>
        <Slider id="banner-slider" {...settings}>
          {featureSongvalue?.length > 0 &&
            featureSongvalue?.map((item, index) => {
              return (
                <Box key={index}>
                  <Box sx={homeStyle.bannerContentBox}>
                    <Box
                      sx={homeStyle.bannerImageContainer}
                      style={{ cursor: "pointer" }}
                    >
                      <Box
                        component="img"
                        sx={homeStyle.bgSongBanner}
                        src={
                          isMobile
                            ? item?.attributes?.homepage_banner_image_mobile
                            : item?.attributes?.homepage_banner_image_desktop
                        }
                        onClick={() => handleMoredetails(item)}
                      />
                    </Box>
                    <Box sx={homeStyle.bannerContent}>
                      <Typography component="p">
                        {item?.attributes?.homepage_banner_line1}
                      </Typography>
                      <Typography variant="h2" sx={homeStyle.bannerTitle}>
                        {item?.attributes?.Title}
                      </Typography>
                      <Typography component="span">
                        {item?.attributes?.homepage_banner_line2}
                      </Typography>
                      <Link
                        onClick={() => handleMoredetails(item)}
                        style={{ color: "black", cursor: "pointer" }}
                      >
                        More Details
                        <Box
                          component="img"
                          src="/images/home/btn-arrow.svg"
                          style={{ width: "17px", height: "20px" }}
                        />
                      </Link>
                    </Box>
                  </Box>
                </Box>
              );
            })}

          {/* <Box>
            <Box sx={homeStyle.bannerContentBox}>
              <Box
                sx={homeStyle.bannerImageContainer}
                style={{ cursor: "pointer" }}
              >
                <Box
                  component="img"
                  sx={homeStyle.bgSongBanner}
                  src="https://d2q23p4t0ij9e0.cloudfront.net/Nusrat_5b59945a9f.jpeg"
                  onClick={() => router.push("/nft/nusrat")}
                />
              </Box>
              <Box sx={homeStyle.bannerContent}>
                <Typography component="p">
                  16M+ Stream . 1M+ Reels on Instagram
                </Typography>
                <Typography variant="h2" sx={homeStyle.bannerTitle}>
                  Nusrat
                </Typography>
                <Typography component="span">
                  Hurry, Only Few NFTs LEFT.
                </Typography>
                <Link href="/nft/nusrat">
                  Buy Now
                  <Box component="img" src="/images/home/btn-arrow.svg" />
                </Link>
              </Box>
            </Box>
          </Box> */}
        </Slider>
      </Box>
      <LoginScreen open={open} onClose={handleClose} />
      {/* {
        hidecommunitypopup ? (
            <></>
        ) : (
           <Modal open={show} onClose={hidePopup} sx={homeStyle.modalHome}>
        <Slide direction="down" in={show} mountOnEnter unmountOnExit>
          <Box className="homePopup" sx={homeStyle.homePopupContainer}>
            <Link
              href="javascript:void(0)"
              className="btn-popupclose"
              onClick={hidePopup}
            >
              <Box component="img" src="/images/home/modal-close-white.svg" />
            </Link>
            <Box className="popupHeader">
              <Typography variant="h1">
                first
                <br /> global
                <br />
                music
                <br /> community is live now
              </Typography>
            </Box>
            <Typography variant="span">
              <Box component="img" src="/images/home/chat.gif" />
            </Typography>
            <Box className="popupFooter">
              <Link href="/community" className="btnJoinCommunity">
                Join Now
              </Link>
            </Box>
            <Link
              href="javascript:void(0)"
              onClick={hidePopup}
              className="btnCloseCommunity"
            >
              CLOSE
            </Link>
          </Box>
        </Slide>
           </Modal>
        )
        } */}

      <Modal
        open={profile?.name == "Guest User"}
        className="scrollModal"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="main-form-section">
          <div className="box">
            <div className="login-container">
              <div className="logo-login01" style={{ marginBottom: "50px" }}>
                <img
                  src="https://fantiger.com/images/home/logo-icon.png"
                  alt=""
                />
              </div>
              <div style={{ marginTop: "-110px", marginLeft: "86px" }}>
                <p>Welcome to FanTiger, Please enter your name to continue</p>
              </div>
              <div className="inputBox">
                <input
                  value={name}
                  name="name"
                  type="text"
                  placeholder="Name*"
                  onChange={(e) => {
                    setName(e.target.value);
                    if (e.target.value) setNameUpdateError(false);
                  }}
                />
                {nameUpdateError && (
                  <div style={{ color: "red", marginTop: "10px" }}>
                    Please enter a valid name
                  </div>
                )}
              </div>
              <div className="create-acc"></div>
              <div className="login-button01">
                <button
                  className="btn"
                  onClick={() => {
                    updateUserName();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Box>
  );
};

export default TopSection;
